import Lenis from '@studio-freight/lenis';
//
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import CSSPlugin from 'gsap/CSSPlugin';
gsap.registerPlugin(ScrollTrigger, CSSPlugin);
//
import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';
Swiper.use([EffectFade, Autoplay]);

//
const setScrollbarWidth = () => {
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	// カスタムプロパティの値を更新する
	document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
};

setScrollbarWidth();

window.addEventListener("load", function () {
	const lenis = new Lenis({
		lerp: 1,
		duration: 0,
		easing: function (t) { return (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)) },
		smooth: true,
		smoothTouch: false,
	});

	function raf(time) {
		lenis.raf(time);
		ScrollTrigger.update();
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);

	const body = document.querySelector('body');
	const btn = document.querySelector('#hbvBtn');
	const menu_target = document.querySelector('.js-header__menu');
	const menu_overlay = document.querySelector('.lp--overlay');
	const hlbtn = document.querySelector('#hbvBtn');
	const hlbtn__Close = document.querySelector('#hbvBtn__Close');
	const hlmenu_target = document.querySelector('#header__lang__body');
	const hlmenu_link = document.querySelectorAll('.hbMenu__list a');


	const anchorLinks = document.querySelectorAll('a[href^="#"]');
	const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
	const header = document.querySelector('.lp--header');
	const anchorHash = location.hash;

	//let state = false;
	hlbtn.addEventListener("click", function () {
		//let nextDom = this.nextElementSibling;

		this.setAttribute('aria-expanded', 'true');
		//
		//menu_target.setAttribute('aria-hidden', 'false');
		//
		//menu_overlay.classList.add('open');
		//
		//body.classList.add('fixed');
		gsap.to(menu_target, {
			ease: "expo.out",
			duration: .56,
			xPercent: -100,

		});

		gsap.to(menu_overlay, {
			ease: "power3.out",
			duration: .4,
			autoAlpha: 1,
			display: "block"
		});
		//hlbtn.style.marginRight = window.innerWidth - document.body.clientWidth + 'px';
		//this.style.marginRight = window.innerWidth - document.body.clientWidth + 'px';
		body.style.paddingRight = window.innerWidth - document.body.clientWidth + 'px';
		lenis.stop();
	});
	hlbtn__Close.addEventListener("click", function () {
		hlbtn.setAttribute('aria-expanded', 'false');

		//menu_target.setAttribute('aria-hidden', 'true');
		gsap.to(menu_target, {
			ease: "expo.out",
			duration: .56,
			xPercent: 0,

		});

		gsap.to(menu_overlay, {
			ease: "power3.out",
			duration: .4,
			autoAlpha: 0,
			display: "none"

		});

		body.style.paddingRight = '0px';
		lenis.start();
	});
	menu_overlay.addEventListener("click", function () {
		hlbtn.setAttribute('aria-expanded', 'false');
		//menu_target.setAttribute('aria-hidden', 'true');
		gsap.to(menu_target, {
			ease: "expo.out",
			duration: .56,
			xPercent: 0,

		});

		gsap.to(menu_overlay, {
			ease: "power3.out",
			duration: .4,
			autoAlpha: 0,
			display: "none"

		});
		body.style.paddingRight = '0px';
		lenis.start();
	});
	hlmenu_link.forEach(link => {
		link.addEventListener('click', e => {
			hlbtn.setAttribute('aria-expanded', 'false');
			//menu_target.setAttribute('aria-hidden', 'true');
			gsap.to(menu_target, {
				ease: "expo.out",
				duration: .56,
				xPercent: 0,

			});

			gsap.to(menu_overlay, {
				ease: "power3.out",
				duration: .4,
				autoAlpha: 0,
				display: "none"

			});
			body.style.paddingRight = '0px';
			lenis.start();
		});
	});

	if (anchorHash) {
		window.scrollTo({
			top: 0,
			behavior: "instant"
		});
		const targetElement = document.querySelector(anchorHash);
		const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
		const headerHeight = header.offsetHeight;
		const totalScrollAmount = targetOffsetTop - headerHeight;

		targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		var tm = 500;
		setTimeout(fn, tm);
	}

	anchorLinksArr.forEach(link => {
		link.addEventListener('click', e => {
			e.preventDefault();
			const targetId = link.hash;
			const targetElement = document.querySelector(targetId);
			const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
			const headerHeight = 0;
			//const totalScrollAmount = targetOffsetTop - headerHeight;
			const totalScrollAmount = targetOffsetTop - headerHeight;
			targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		});
	});



	//

	const viewAnimTarget = document.querySelectorAll('[data-view-cont="true"]');

	viewAnimTarget.forEach((cont) => {
		let viewAnimItem = cont.querySelectorAll('[data-view-item]');
		//let viewAnimItemLength = viewAnimItem.length;

		const viewTimeline = gsap.timeline({
			scrollTrigger: {
				trigger: cont,
				start: "top center",
				//markers:true,
			},
		});

		viewTimeline.fromTo(
			viewAnimItem,
			{
				autoAlpha: 0,
				y: 30
			},
			{
				y: 0,
				autoAlpha: 1,
				duration: .4,
				stagger: {
					each: .1,
				}
			},

		);

		viewAnimItem.forEach((item) => {
			//console.log(item);
		});
	});


	const headings = document.querySelectorAll('.change__color');

	const options = {
		root: null,
		rootMargin: "0px 0px 0px 0px",
		threshold: 0
	};

	const observer = new IntersectionObserver(showElements, options);


	headings.forEach(heading => {
		observer.observe(heading);
	});

	function showElements(entries) {
		/*entries.forEach(entry => {
			if (entry.isIntersecting) {
				gsap.to(entry.target, .7, { filter: 'filter: brightness(100%)' , opacity: 1, y: 0, ease: 'power1.out' });
			}
		});*/
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				header.classList.remove('is-change');
				//gsap.to(entry.target, .7, { filter: 'filter: brightness(100%)' , opacity: 1, y: 0, ease: 'power1.out' });
			} else {
				header.classList.add('is-change');
			}
		});
	};





	//
	const swiper = new Swiper(".hero__bg .swiper", {
		modules: [Autoplay, EffectFade],
		loop: true,
		speed: 4000,
		slidesPerView: 1,
		autoplay: {
			delay: 6000,
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
	});
	//
	//
	//
	//
	//
	//
	const initThumbLinkedSlider = (slideSelector, thumbSelector) => {
		const slideRoot = document.querySelector(slideSelector);
		const thumbRoot = document.querySelector(thumbSelector);
		if (!slideRoot || !thumbRoot) return;

		const swiperEl = slideRoot.querySelector('.swiper');
		const thumbButtons = Array.from(thumbRoot.querySelectorAll('button'));
		if (!swiperEl || thumbButtons.length === 0) return;

		const slider = new Swiper(swiperEl, {
			loop: false,
			speed: 600,
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			observer: true,
			observeParents: true,
		});

		const setActiveThumb = (index) => {
			thumbButtons.forEach((button, i) => {
				const isActive = i === index;
				button.classList.toggle('is-active', isActive);
				const li = button.closest('li');
				if (li) {
					li.classList.toggle('is-active', isActive);
				}
				button.setAttribute('aria-current', isActive ? 'true' : 'false');
			});
		};

		setActiveThumb(0);

		thumbButtons.forEach((button, index) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				slider.slideTo(index);
				setActiveThumb(index);
			});
		});

		slider.on('slideChange', () => {
			const currentIndex = typeof slider.realIndex === 'number' ? slider.realIndex : slider.activeIndex;
			setActiveThumb(currentIndex);
		});
	};

	initThumbLinkedSlider('#slideA', '#thumbA');
	initThumbLinkedSlider('#slideB', '#thumbB');
	//
	//
	//
	//
	//
	//
	const heroPartyPos = document.querySelector(".party").getBoundingClientRect().top;
	const heroAboutPos = document.querySelector(".hero__about").getBoundingClientRect().top;

	console.log(heroPartyPos);

	const heroBgAnim = gsap.timeline({
		scrollTrigger: {
			trigger: document.querySelector(".hero__bg"),
			start: "top top",
			endTrigger: document.querySelector(".party"),
			end: 'top bottom',
			pinSpacing: false,
			pin: true,
			scrub: true,
			invalidateOnRefresh: false,
		}
	});
	heroBgAnim.fromTo(('.hero__text-title'), {
		autoAlpha: 1,
		y: 0
	}, {
		y: 80,
		autoAlpha: 0,
		ease: "none",
		duration: .1
	});
	heroBgAnim.fromTo(('.hero__bg-overlay'), {
		autoAlpha: 0,
		y: 0
	}, {
		y: 0,
		autoAlpha: 1,
		ease: "none",
		duration: .5
	});
	heroBgAnim.fromTo(('.hero__bg-overlay'), {
		autoAlpha: 1,
		y: 0
	}, {
		y: 0,
		autoAlpha: 1,
		ease: "none",
		duration: .4
	});


	//
	const heroAnim = gsap.timeline({
		scrollTrigger: {
			trigger: document.querySelector(".hero__about-pic"),
			start: "top+=200px bottom",
			end: "top+=400px bottom",
			scrub: true,
			invalidateOnRefresh: false,
		}
	});
	heroAnim.fromTo(('.hero__about-pic'), {
		autoAlpha: 0,
		y: 30
	}, {
		y: 0,
		autoAlpha: 1,
		ease: "none",
	});
	heroAnim.fromTo(('.hero__about-text'), {
		autoAlpha: 0,
		y: 30
	}, {
		y: 0,
		autoAlpha: 1,
		ease: "none",
	}, "=");


	//
	const navLinks = document.querySelectorAll(".faq__nav a");
	const tabs = document.querySelectorAll(".faq__tab");

	navLinks.forEach(link => {
		link.addEventListener("click", function (e) {
			e.preventDefault();

			// すべてリセット
			navLinks.forEach(nav => nav.setAttribute("aria-expanded", "false"));
			tabs.forEach(tab => tab.setAttribute("aria-hidden", "true"));

			// 現在のリンクと対象タブを有効化
			this.setAttribute("aria-expanded", "true");
			const targetId = this.getAttribute("href").replace("#", "");
			const targetTab = document.getElementById(targetId);
			if (targetTab) {
				targetTab.setAttribute("aria-hidden", "false");

				// スムーススクロール
				targetTab.scrollIntoView({
					behavior: "smooth",
					block: "start"
				});
			}
		});
	});
});
window.addEventListener("resize", function () {
	setScrollbarWidth();
});
